import React from 'react';
import './JobFilter.css';

const JobFilter = ({
  availableCategories,
  availableLocations,
  filterCategory,
  filterLocation,
  onCategoryChange,
  onLocationChange,
}) => {
  return (
    <div className='job-filter'>
      <select
        onChange={(e) => onCategoryChange(e.target.value)}
        value={filterCategory}
      >
        {availableCategories.map((category, index) => (
          <option key={index} value={category}>
            {category}
          </option>
        ))}
      </select>

      <select
        onChange={(e) => onLocationChange(e.target.value)}
        value={filterLocation}
      >
        {availableLocations.map((location, index) => (
          <option key={index} value={location}>
            {location}
          </option>
        ))}
      </select>
    </div>
  );
};

export default JobFilter;
